import { render, staticRenderFns } from "./RapidTestReport.vue?vue&type=template&id=84288476&scoped=true&"
import script from "./RapidTestReport.vue?vue&type=script&lang=js&"
export * from "./RapidTestReport.vue?vue&type=script&lang=js&"
import style0 from "./RapidTestReport.scss?vue&type=style&index=0&id=84288476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84288476",
  null
  
)

export default component.exports